import { BreadCrumbRef } from "@/types"

export const createBreadCrumbSearchParam = (breadCrumbRef: BreadCrumbRef): string => {
  const titles = breadCrumbRef.map(breadcrumb => breadcrumb.text).join(",")
  const links = breadCrumbRef.map(breadcrumb => breadcrumb.link).join(",")
  return `refTitles=${encodeURIComponent(titles)}&refLinks=${encodeURIComponent(links)}`
}

export const createUrlWithBreadCrumb = ({
  url,
  breadCrumbRef,
}: {
  url: string
  breadCrumbRef?: BreadCrumbRef
}): string => {
  const search = breadCrumbRef ? createBreadCrumbSearchParam(breadCrumbRef) : null
  return search ? `${url}?${search}` : url
}
